import Breadcrumb from './Breadcrumb';
export default Breadcrumb;
export { default as getData } from './getData';